var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-ras" }, [
    _vm.isNetError
      ? _c("div", { staticClass: "net-error-tip" }, [_vm._v("当前网络异常")])
      : _vm._e(),
    _c("div", { staticClass: "page-header" }, [
      _c("img", {
        attrs: { src: _vm.ossHost + "img/ras-header-bg.png", alt: "" }
      })
    ]),
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "content-main" }, [
        _c("div", { staticClass: "content-top-row" }, [
          _c("div", { staticClass: "panel base-info-panel" }, [
            _c("div", { staticClass: "box-title" }, [_vm._v("基地概况")]),
            _c(
              "div",
              { staticClass: "base-info-list" },
              _vm._l(_vm.baseInfoList, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "base-info-item" },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.ossHost + "img/ras-info-" + item.icon + ".png",
                        alt: ""
                      }
                    }),
                    _c("div", { staticClass: "info-text" }, [
                      _c("div", { staticClass: "item-val" }, [
                        _vm._v(_vm._s(item.value)),
                        item.unit
                          ? _c("span", [_vm._v(_vm._s(item.unit))])
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "item-label" }, [
                        _vm._v(_vm._s(item.label))
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _c(
            "div",
            { staticClass: "panel center-top" },
            [
              !_vm.isShowAreaDetail
                ? [
                    _c(
                      "div",
                      {
                        key: "manage-btn",
                        staticClass: "manage-btn",
                        on: { click: _vm.openManagePanel }
                      },
                      [_vm._v("管理")]
                    ),
                    _c(
                      "div",
                      {
                        key: "greenhouse-grid",
                        staticClass: "greenhouse-grid"
                      },
                      [
                        _vm._l(_vm.regionList, function(area, index) {
                          return _c(
                            "div",
                            {
                              key: area.rasAreaId,
                              staticClass: "greenhouse-item",
                              style: _vm.getGreenhouseStyle(index),
                              on: {
                                mouseenter: function($event) {
                                  return _vm.onHoverArea(area)
                                },
                                click: function($event) {
                                  return _vm.enterArea(area)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    _vm.ossHost +
                                    "img/" +
                                    (area.ryWarningType > 0
                                      ? "greenhouse-active.png"
                                      : "greenhouse.png"),
                                  alt: ""
                                }
                              })
                            ]
                          )
                        }),
                        _vm._l(_vm.regionList, function(area, index) {
                          return _c(
                            "div",
                            {
                              key: "name-" + area.rasAreaId,
                              class: {
                                "greenhouse-name": true,
                                warning: area.ryWarningType > 0
                              },
                              style: _vm.getGreenhouseNameStyle(index)
                            },
                            [_vm._v(_vm._s(area.name))]
                          )
                        })
                      ],
                      2
                    )
                  ]
                : [
                    _c(
                      "div",
                      {
                        key: "tools-left",
                        staticClass: "detail-tools left-tools"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tool-btn",
                            on: { click: _vm.backToHome }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-arrow-left back-icon"
                            }),
                            _vm._v("返回")
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        key: "tools-right",
                        staticClass: "detail-tools right-tools"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tool-btn",
                            on: { click: _vm.addBarrel }
                          },
                          [_vm._v("添加")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "tool-btn",
                            class: { disabled: !_vm.barrels.length },
                            on: { click: _vm.manageBarrels }
                          },
                          [_vm._v("管理")]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "detail-stage" },
                      [
                        !_vm.barrels.length
                          ? _c("div", { staticClass: "empty-tip" }, [
                              _vm._v("暂未添加水质监测设备")
                            ])
                          : _vm._e(),
                        _vm._l(_vm.barrelRowIndexes(), function(
                          rowIndexes,
                          rowKey
                        ) {
                          return _c(
                            "div",
                            { key: "row" + rowKey, staticClass: "barrel-row" },
                            _vm._l(rowIndexes, function(index) {
                              return _c(
                                "div",
                                {
                                  key:
                                    _vm.barrels[index].columnId ||
                                    _vm.barrels[index].uniqueId ||
                                    index,
                                  class: {
                                    "barrel-item": true,
                                    "barrel-warning":
                                      _vm.barrels[index].warningType > 0
                                  },
                                  style: _vm.getBarrelSlotStyle(index),
                                  on: {
                                    click: function($event) {
                                      return _vm.selectBarrel(index)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "barrel-info" }, [
                                    _c("div", { staticClass: "barrel-name" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.barrels[index].name ||
                                            index + 1 + "号桶"
                                        )
                                      )
                                    ]),
                                    _c("div", { staticClass: "barrel-desc" }, [
                                      _vm._v(
                                        "溶氧：" +
                                          _vm._s(
                                            _vm.barrels[index]
                                              .dissolvedOxygen == null
                                              ? "--"
                                              : _vm.barrels[index]
                                                  .dissolvedOxygen + "mg/L"
                                          )
                                      )
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "barrel-desc",
                                        class: {
                                          "desc-hidden": !_vm.barrels[index]
                                            .showDepth
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "液位：" +
                                            _vm._s(
                                              _vm.barrels[index].depth == null
                                                ? "--"
                                                : _vm.barrels[index].depth + "m"
                                            )
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("img", {
                                    staticClass: "barrel-img",
                                    attrs: {
                                      src:
                                        _vm.ossHost +
                                        "img/" +
                                        (_vm.barrels[index].warningType > 0
                                          ? "barrel-active.png"
                                          : "barrel.png"),
                                      alt: ""
                                    }
                                  })
                                ]
                              )
                            }),
                            0
                          )
                        })
                      ],
                      2
                    )
                  ]
            ],
            2
          )
        ]),
        _c("div", { staticClass: "content-bottom-row" }, [
          _c("div", { staticClass: "panel risk-panel" }, [
            _c("div", { staticClass: "box-title" }, [_vm._v("风险预警")]),
            _c(
              "div",
              { staticClass: "risk-list" },
              _vm._l(_vm.riskList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: item.key || index,
                    class: { "risk-item": true, unread: item.unread }
                  },
                  [
                    item.unread
                      ? _c("i", {
                          staticClass: "risk-icon el-icon-warning-outline"
                        })
                      : _vm._e(),
                    _c("div", { staticClass: "risk-text" }, [
                      _vm._v(_vm._s(item.text))
                    ]),
                    item.time
                      ? _c("div", { staticClass: "risk-time" }, [
                          _vm._v(_vm._s(item.time))
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ]),
          _c("div", { staticClass: "panel center-bottom" }, [
            _c("div", { staticClass: "box-title" }, [_vm._v("基地概况")]),
            _c("div", { staticClass: "stats-cards" }, [
              _c("div", { staticClass: "stat-card" }, [
                _vm._m(0),
                _c("div", { staticClass: "stat-val" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.energyFeed.abnormalBarrelCount || 0))
                  ]),
                  _vm._v("个")
                ])
              ]),
              _c("div", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-top" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.ossHost + "img/icon-electricity.png",
                      alt: ""
                    }
                  }),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("今日用电")])
                ]),
                _c("div", { staticClass: "stat-val" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.energyFeed.todayElectricity || 0))
                  ]),
                  _vm._v("度")
                ])
              ]),
              _c("div", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-top" }, [
                  _c("img", {
                    attrs: { src: _vm.ossHost + "img/icon-feed.png", alt: "" }
                  }),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("今日投料")])
                ]),
                _c("div", { staticClass: "stat-val" }, [
                  _c("b", [_vm._v(_vm._s(_vm.energyFeed.todayFeed || 0))]),
                  _vm._v("斤")
                ])
              ])
            ]),
            _c("div", {
              staticClass: "energy-chart",
              attrs: { id: "energy-chart" }
            })
          ])
        ])
      ]),
      _c("div", { staticClass: "panel page-content-right" }, [
        _c("div", { staticClass: "box-title" }, [
          _vm._v(
            _vm._s(
              _vm.isShowAreaDetail
                ? _vm.currentAreaName + "主要设备"
                : "基地设备总览"
            )
          )
        ]),
        _c(
          "div",
          { staticClass: "kzq-ctrl-list" },
          _vm._l(_vm.ctrlList, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                class: {
                  "list-item": true,
                  empty: !item.devCount,
                  warning: item.warnCount > 0,
                  readonly: !_vm.isShowAreaDetail
                },
                on: {
                  click: function($event) {
                    return _vm.onDeviceRowClick(item)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "dev-icon",
                  class: { "fedder-icon": item.type == 9 },
                  attrs: { src: _vm.deviceIcon(item.type), alt: "" }
                }),
                _c("div", { staticClass: "device-info" }, [
                  _c("div", { staticClass: "device-name" }, [
                    _vm._v(_vm._s(item.name))
                  ]),
                  item.devCount
                    ? _c("div", { staticClass: "device-status" }, [
                        _c("div", { staticClass: "status-item" }, [
                          _c("div", { staticClass: "num" }, [
                            _vm._v(_vm._s(item.runningCount || 0) + "台")
                          ]),
                          _c("div", { staticClass: "status" }, [_vm._v("正常")])
                        ]),
                        _c("div", { staticClass: "status-item" }, [
                          _c("div", { staticClass: "num" }, [
                            _vm._v(_vm._s(item.waitCount || 0) + "台")
                          ]),
                          _c("div", { staticClass: "status" }, [_vm._v("待机")])
                        ]),
                        _c("div", { staticClass: "status-item" }, [
                          _c(
                            "div",
                            { class: { num: true, warn: item.warnCount > 0 } },
                            [_vm._v(_vm._s(item.warnCount || 0) + "台")]
                          ),
                          _c("div", { staticClass: "status" }, [_vm._v("异常")])
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm.isShowAreaDetail
                  ? _c("i", {
                      staticClass: "el-icon-circle-plus add-icon",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.onDeviceRowClick(item)
                        }
                      }
                    })
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ])
    ]),
    _vm.isShowManagePanel
      ? _c("div", { staticClass: "greenhouse-manage" }, [
          _c("div", {
            staticClass: "manage-bg",
            on: {
              click: function($event) {
                _vm.isShowManagePanel = false
              }
            }
          }),
          _c("div", { staticClass: "manage-panel" }, [
            _c("div", { staticClass: "manage-left" }, [
              _c("img", {
                attrs: { src: _vm.ossHost + "img/ras-info-3.png", alt: "" }
              }),
              _c("div", { staticClass: "manage-title" }, [_vm._v("分组管理")]),
              _c("div", { staticClass: "manage-sub" }, [
                _vm._v("当前" + _vm._s(_vm.regionList.length) + "个分组")
              ])
            ]),
            _c("div", { staticClass: "manage-right" }, [
              _c("div", { staticClass: "list-head" }, [_vm._v("分组名称")]),
              _c(
                "div",
                {
                  staticClass: "btn add-btn",
                  on: {
                    click: function($event) {
                      return _vm.openGreenhouseModal("add")
                    }
                  }
                },
                [_vm._v("添加")]
              ),
              _c(
                "div",
                { staticClass: "manage-list" },
                _vm._l(_vm.pagedRegionList, function(area, index) {
                  return _c(
                    "div",
                    { key: area.rasAreaId, staticClass: "manage-row" },
                    [
                      _c("div", { staticClass: "row-index" }, [
                        _vm._v(_vm._s((_vm.managePage - 1) * 6 + index + 1))
                      ]),
                      _c("div", { staticClass: "row-name" }, [
                        _vm._v(_vm._s(area.name))
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "btn edit-btn",
                          on: {
                            click: function($event) {
                              return _vm.openGreenhouseModal("edit", area)
                            }
                          }
                        },
                        [_vm._v("编辑")]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm.managePageCount > 1
                ? _c(
                    "div",
                    { staticClass: "manage-pager" },
                    _vm._l(_vm.managePageCount, function(page) {
                      return _c(
                        "span",
                        {
                          key: page,
                          class: { cur: _vm.managePage === page },
                          on: {
                            click: function($event) {
                              _vm.managePage = page
                            }
                          }
                        },
                        [_vm._v(_vm._s(page))]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          ])
        ])
      : _vm._e(),
    _c(
      "div",
      { class: { "greenhouse-modal": true, show: _vm.isShowGreenhouseModal } },
      [
        _c("div", {
          staticClass: "modal-bg",
          on: {
            click: function($event) {
              _vm.isShowGreenhouseModal = false
            }
          }
        }),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "modal-title" }, [
            _vm._v(
              _vm._s(
                _vm.greenhouseModal.mode === "edit" ? "重命名大棚" : "新建大棚"
              )
            )
          ]),
          _c("div", { staticClass: "modal-input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.greenhouseModal.value,
                  expression: "greenhouseModal.value"
                }
              ],
              attrs: {
                type: "text",
                maxlength: "10",
                placeholder: "点击输入新的大棚名称"
              },
              domProps: { value: _vm.greenhouseModal.value },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.greenhouseModal, "value", $event.target.value)
                }
              }
            })
          ]),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    _vm.isShowGreenhouseModal = false
                  }
                }
              },
              [_vm._v("取 消")]
            ),
            _c(
              "div",
              {
                staticClass: "btn confirm-btn",
                on: { click: _vm.saveGreenhouse }
              },
              [_vm._v("确 定")]
            )
          ])
        ])
      ]
    ),
    _c("div", { class: { "add-device-modal": true, show: _vm.isShowModal } }, [
      _c("div", {
        staticClass: "modal-bg",
        on: {
          click: function($event) {
            _vm.isShowModal = false
          }
        }
      }),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "modal-body-left" }, [
          _vm.clickRegionDeviceType == 8
            ? _c("img", {
                attrs: { src: _vm.ossHost + "img/dbmc_xfm.png", alt: "" }
              })
            : _c("img", {
                class: { "fedder-icon": _vm.clickRegionDeviceType == 9 },
                attrs: {
                  src: _vm.deviceIcon(_vm.clickRegionDeviceType),
                  alt: ""
                }
              }),
          _c("div", { staticClass: "device-type" }, [
            _vm._v(_vm._s(_vm.curOpenModalBindDevices.name))
          ]),
          _vm.curOpenModalBindDevices.deviceViews &&
          _vm.curOpenModalBindDevices.deviceViews.length
            ? _c("div", { staticClass: "device-num" }, [
                _vm._v(
                  "当前" +
                    _vm._s(_vm.curOpenModalBindDevices.deviceViews.length) +
                    "台"
                )
              ])
            : _c("div", { staticClass: "device-num" }, [_vm._v("当前0台")])
        ]),
        _c("div", { staticClass: "modal-body-right" }, [
          _c(
            "div",
            { staticClass: "list-box" },
            [
              _c("div", { staticClass: "list-box-item header" }, [
                _c("div", [_vm._v("设备编号")]),
                _c("div", [_vm._v("自定义名称")]),
                _vm.clickRegionDeviceType == 8 ||
                (_vm.curOpenModalBindDevices.deviceViews &&
                  _vm.curOpenModalBindDevices.deviceViews.length < 4)
                  ? _c(
                      "div",
                      {
                        staticClass: "add-btn btn",
                        on: { click: _vm.onclickAddDeviceBtn }
                      },
                      [_vm._v("添加")]
                    )
                  : _c("div", { staticClass: "add-btn btn disabled" }, [
                      _vm._v("添加")
                    ])
              ]),
              _vm._l(_vm.pagedDeviceViews, function(device, index) {
                return _c(
                  "div",
                  { key: device.uniqueId, staticClass: "list-box-item" },
                  [
                    _c("div", { staticClass: "item-index" }, [
                      _vm._v(_vm._s(_vm.devicePageOffset + index + 1))
                    ]),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: device.uniqueId,
                            expression: "device.uniqueId"
                          }
                        ],
                        attrs: { type: "text", readonly: "" },
                        domProps: { value: device.uniqueId },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(device, "uniqueId", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: device.name,
                            expression: "device.name"
                          }
                        ],
                        attrs: { type: "text", readonly: "" },
                        domProps: { value: device.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(device, "name", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "edit-btn btn",
                        on: {
                          click: function($event) {
                            return _vm.oncllickCtrlItem(
                              _vm.devicePageOffset + index
                            )
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _c("div", {
                      staticClass: "delete-btn",
                      on: {
                        click: function($event) {
                          return _vm.onclickDelItem(
                            _vm.devicePageOffset + index
                          )
                        }
                      }
                    })
                  ]
                )
              })
            ],
            2
          ),
          _vm.devicePageCount > 1
            ? _c(
                "div",
                { staticClass: "device-pager" },
                _vm._l(_vm.devicePageCount, function(page) {
                  return _c(
                    "span",
                    {
                      key: page,
                      class: { cur: _vm.safeDevicePage === page },
                      on: {
                        click: function($event) {
                          _vm.devicePage = page
                        }
                      }
                    },
                    [_vm._v(_vm._s(page))]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.clickRegionDeviceType == 8
            ? _c(
                "div",
                {
                  class: { "setting-box": true, "has-wl": _vm.hasCbmWLDevice }
                },
                [
                  _c("div", { staticClass: "ry-item" }, [
                    _vm._v(" 溶氧告警值 "),
                    !_vm.deviceSettingInfo.status
                      ? _c("div", { staticClass: "ry-setting-val disabled" }, [
                          _vm._v(
                            " " + _vm._s(_vm.deviceSettingInfo.minOxygen) + " "
                          )
                        ])
                      : _c(
                          "div",
                          {
                            staticClass: "ry-setting-val",
                            on: {
                              mouseenter: function($event) {
                                _vm.isShowSettingList = true
                              },
                              mouseleave: function($event) {
                                _vm.isShowSettingList = false
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.deviceSettingInfo.minOxygen) +
                                " "
                            ),
                            _c("b"),
                            _c(
                              "div",
                              {
                                class: {
                                  "slelect-list": true,
                                  show: _vm.isShowSettingList
                                }
                              },
                              _vm._l(16, function(index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "list-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.onSelectSetting(8, index)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(index))]
                                )
                              }),
                              0
                            )
                          ]
                        ),
                    _vm.deviceSettingInfo.minOxygen != null
                      ? _c("span", { staticClass: "ry-unit" }, [_vm._v("mg/L")])
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "setting-tip" }, [
                    _vm._v("*溶氧低于设定的值时，会主动告警")
                  ]),
                  _vm.hasCbmWLDevice
                    ? _c("div", { staticClass: "ry-item" }, [
                        _vm._v(" 高水位告警 "),
                        _c(
                          "div",
                          {
                            staticClass: "ry-setting-val",
                            on: {
                              click: function($event) {
                                return _vm.onclickWLValItem("high")
                              }
                            }
                          },
                          [
                            _vm.deviceSettingInfo.cbmWLHighWarningVal != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.deviceSettingInfo.cbmWLHighWarningVal
                                    )
                                  )
                                ])
                              : _c("span", { staticClass: "placeholder" }, [
                                  _vm._v("请输入")
                                ])
                          ]
                        ),
                        _vm.deviceSettingInfo.cbmWLHighWarningVal != null
                          ? _c("span", { staticClass: "ry-unit" }, [
                              _vm._v("m")
                            ])
                          : _vm._e(),
                        _c("div", {
                          class: {
                            "switch-box": true,
                            inline: true,
                            close: !_vm.deviceSettingInfo.cbmWLHighWarning
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSelectCbmWLSetting("high", -1)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm.hasCbmWLDevice
                    ? _c("div", { staticClass: "ry-item" }, [
                        _vm._v(" 低水位告警 "),
                        _c(
                          "div",
                          {
                            staticClass: "ry-setting-val",
                            on: {
                              click: function($event) {
                                return _vm.onclickWLValItem("low")
                              }
                            }
                          },
                          [
                            _vm.deviceSettingInfo.cbmWLLowWarningVal != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.deviceSettingInfo.cbmWLLowWarningVal
                                    )
                                  )
                                ])
                              : _c("span", { staticClass: "placeholder" }, [
                                  _vm._v("请输入")
                                ])
                          ]
                        ),
                        _vm.deviceSettingInfo.cbmWLLowWarningVal != null
                          ? _c("span", { staticClass: "ry-unit" }, [
                              _vm._v("m")
                            ])
                          : _vm._e(),
                        _c("div", {
                          class: {
                            "switch-box": true,
                            inline: true,
                            close: !_vm.deviceSettingInfo.cbmWLLowWarning
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSelectCbmWLSetting("low", -1)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _c("div", {
                    class: {
                      "switch-box": true,
                      close: !_vm.deviceSettingInfo.status
                    },
                    on: {
                      click: function($event) {
                        return _vm.onSelectSetting(8, -1)
                      }
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm.clickRegionDeviceType == 0
            ? _c("div", { staticClass: "setting-box" }, [
                _c("div", { staticClass: "ry-item" }, [
                  _vm._v(" 轮泵周期 "),
                  !_vm.deviceSettingInfo.status
                    ? _c("div", { staticClass: "ry-setting-val disabled" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.deviceSettingInfo.lbDurationSec
                                ? (
                                    _vm.deviceSettingInfo.lbDurationSec / 3600
                                  ).toFixed(0)
                                : 2
                            ) +
                            "小时 "
                        )
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "ry-setting-val",
                          on: {
                            mouseenter: function($event) {
                              _vm.isShowSettingList = true
                            },
                            mouseleave: function($event) {
                              _vm.isShowSettingList = false
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.deviceSettingInfo.lbDurationSec
                                  ? (
                                      _vm.deviceSettingInfo.lbDurationSec / 3600
                                    ).toFixed(0)
                                  : 2
                              ) +
                              "小时 "
                          ),
                          _c("b"),
                          _c(
                            "div",
                            {
                              class: {
                                "slelect-list": true,
                                show: _vm.isShowSettingList
                              }
                            },
                            _vm._l(24, function(index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "list-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.onSelectSetting(0, index)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(index))]
                              )
                            }),
                            0
                          )
                        ]
                      )
                ]),
                _c("div", { staticClass: "setting-tip" }, [
                  _vm._v("*开满对应时长后自动切换下一台")
                ]),
                _c("div", {
                  class: {
                    "switch-box": true,
                    close: !_vm.deviceSettingInfo.status
                  },
                  on: {
                    click: function($event) {
                      return _vm.onSelectSetting(0, -1)
                    }
                  }
                })
              ])
            : _vm._e()
        ])
      ])
    ]),
    _c("div", { class: { "wl-val-modal": true, show: _vm.isShowWLValModal } }, [
      _c("div", {
        staticClass: "modal-bg",
        on: { click: _vm.onCancelWLValModal }
      }),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "modal-title" }, [
          _vm._v(
            _vm._s(_vm.wlValField === "high" ? "高水位告警值" : "低水位告警值")
          )
        ]),
        _c("div", { staticClass: "modal-input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.wlValInput,
                expression: "wlValInput"
              }
            ],
            attrs: { type: "text", placeholder: "请输入水位告警值" },
            domProps: { value: _vm.wlValInput },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.wlValInput = $event.target.value
              }
            }
          })
        ]),
        _c("div", { staticClass: "modal-footer" }, [
          _c(
            "div",
            { staticClass: "btn", on: { click: _vm.onCancelWLValModal } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "btn confirm-btn",
              on: { click: _vm.onConfirmWLValModal }
            },
            [_vm._v("确 定")]
          )
        ])
      ])
    ]),
    _c(
      "div",
      { class: { "edit-device-modal": true, show: _vm.isShowEditModal } },
      [
        _c("div", {
          staticClass: "modal-bg",
          on: {
            click: function($event) {
              _vm.isShowEditModal = false
            }
          }
        }),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "list" }, [
            _c(
              "div",
              { class: { "list-item": true, readonly: _vm.deviceInfo.isEdit } },
              [
                _c("div", { staticClass: "label-item" }, [_vm._v("*设备编号")]),
                _c("div", { staticClass: "input-item" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.deviceInfo.uniqueId,
                        expression: "deviceInfo.uniqueId"
                      }
                    ],
                    attrs: {
                      type: "text",
                      maxlength: "8",
                      readonly: _vm.deviceInfo.isEdit,
                      placeholder: "请输入设备编号"
                    },
                    domProps: { value: _vm.deviceInfo.uniqueId },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.deviceInfo,
                          "uniqueId",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]
            ),
            _vm.clickRegionDeviceType != 8 && _vm.clickRegionDeviceType != 9
              ? _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "label-item" }, [
                    _vm._v("*进线方式")
                  ]),
                  !_vm.deviceInfo.isEdit
                    ? _c(
                        "div",
                        {
                          staticClass: "input-item select-item",
                          on: {
                            mouseenter: function($event) {
                              _vm.isShowWorkTypeList = true
                            },
                            mouseleave: function($event) {
                              _vm.isShowWorkTypeList = false
                            }
                          }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.deviceInfo.workType,
                                expression: "deviceInfo.workType"
                              }
                            ],
                            attrs: {
                              type: "text",
                              readonly: "",
                              placeholder: "请选择"
                            },
                            domProps: { value: _vm.deviceInfo.workType },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.deviceInfo,
                                  "workType",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _c("div", {
                            class: { icon: true, on: _vm.isShowWorkTypeList }
                          }),
                          _c(
                            "div",
                            {
                              class: {
                                "slelect-list": true,
                                show: _vm.isShowWorkTypeList
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onSelectWorkType("220V")
                                    }
                                  }
                                },
                                [_vm._v("220V")]
                              ),
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onSelectWorkType("380V")
                                    }
                                  }
                                },
                                [_vm._v("380V")]
                              )
                            ]
                          )
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "input-item select-item readonly" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.deviceInfo.workType,
                                expression: "deviceInfo.workType"
                              }
                            ],
                            attrs: { type: "text", readonly: "" },
                            domProps: { value: _vm.deviceInfo.workType },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.deviceInfo,
                                  "workType",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                ])
              : _vm._e(),
            _vm.clickRegionDeviceType != 8 && _vm.clickRegionDeviceType != 9
              ? _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "label-item" }, [
                    _vm._v("*设备功率")
                  ]),
                  _c("div", { staticClass: "input-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.deviceInfo.power,
                          expression: "deviceInfo.power"
                        }
                      ],
                      attrs: { type: "text", placeholder: "请输入功率" },
                      domProps: { value: _vm.deviceInfo.power },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.deviceInfo, "power", $event.target.value)
                        }
                      }
                    }),
                    _c("div", { staticClass: "unit" }, [_vm._v("千瓦")])
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "list-item" }, [
              _c("div", { staticClass: "label-item" }, [_vm._v("设备名称")]),
              _c("div", { staticClass: "input-item" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.deviceInfo.name,
                      expression: "deviceInfo.name"
                    }
                  ],
                  attrs: {
                    type: "text",
                    maxlength: _vm.deviceInfo.type == 8 ? 8 : null,
                    placeholder: "请输入设备名称"
                  },
                  domProps: { value: _vm.deviceInfo.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.deviceInfo, "name", $event.target.value)
                    }
                  }
                })
              ])
            ])
          ]),
          _c("div", { staticClass: "footer" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    _vm.isShowEditModal = false
                  }
                }
              },
              [_vm._v("取消")]
            ),
            _c(
              "div",
              {
                staticClass: "btn confirm-btn",
                on: { click: _vm.onclickSaveBtn }
              },
              [_vm._v("确定")]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-top" }, [
      _c("i", { staticClass: "el-icon-warning-outline stat-icon" }),
      _c("div", { staticClass: "stat-label" }, [_vm._v("异常圆桶")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }